import { render, staticRenderFns } from "./SliderCarousel.vue?vue&type=template&id=65a0e984"
import script from "./SliderCarousel.vue?vue&type=script&lang=js"
export * from "./SliderCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports